// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__LH-tn","slick-next":"CustomSlider_slick-next__2s7Zt"};